<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">

    <div class="information-margin"></div>

    <!-- メッセージ -->
    <div class="message">
      <!-- メッセージ本文 -->
      <div class="message-text">
        <div class="p-d-flex p-jc-center">
          <i class="pi pi-check-circle" style="font-size: 6rem"></i><br />
        </div>
        <div class="message-margin"></div>
        <div class="p-d-flex p-jc-center">分科会参加登録完了</div>
      </div>
    </div>

    <!-- 本文 -->
    <div class="main-text">
      <p class="p-d-flex p-jc-center font-color">
        分科会ページの「参加中の分科会」をご確認ください。
      </p>
    </div>

    <!-- ボタンエリア -->
    <div class="p-d-flex p-jc-center button-area">
      <button
        pButton
        type="button"
        label="分科会ページへ"
        class="button-default-size button1"
        (click)="moveE201()"
      ></button>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
